import { render } from "./FAQs.vue?vue&type=template&id=1777ca86&scoped=true"
import script from "./FAQs.vue?vue&type=script&lang=js"
export * from "./FAQs.vue?vue&type=script&lang=js"

import "./FAQs.vue?vue&type=style&index=0&id=1777ca86&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\Admin_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1777ca86"]])

export default __exports__